import React, { useEffect, useState, useMemo } from "react";
import { authHeader } from "../_helpers";
import axios from "axios";
import moment from "moment";
import Sidebar from "./component/Sidebar";
import TablePagination from "@mui/material/TablePagination";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  CircularProgress,
  Chip
} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import {
  useNavigate,
  useLocation,
  Navigate,
  useParams,
} from "react-router-dom";
import ToastMessageComp from "../component/ToastMessageComp";
import { alertActions } from "../_actions";
import InputAdornment from "@mui/material/InputAdornment";
//-- add ccode
import IconButton from "@mui/material/IconButton";
import { Menu } from "@mui/material";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CreateIcon from "@mui/icons-material/Create";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Anchor from "../_helpers/anchor";
import { MdDeleteOutline, MdEditSquare } from "react-icons/md";
import { FiSend } from "react-icons/fi";
import LoadingButton from "@mui/lab/LoadingButton";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { frFR } from "@mui/x-date-pickers/locales";
import dayjs from "dayjs";
import "dayjs/locale/fr.js";
import SaveIcon from "@mui/icons-material/Save";

export default function Clientdetails() {
  const alert = useSelector((state) => state.alert);
  const params = useParams();
  const dispatch = useDispatch();
  const [civilite, setCivilite] = useState("");
  const [userDetails, setUserDetails] = useState("");
  const [AnnounceData, setAnnounceData] = useState([]);
  const [announceTotal, setAnnounceTotal] = useState(0);
  const [FactureData, setFactureData] = useState([]);
  const [factureTotal, setFactureTotal] = useState(0);
  const [facturePage, setFacturePage] = useState(0);
  const [factureRowsPerPage, setFactureRowsPerPage] = useState(5);
  const [AnnouncePendingData, setAnnouncePendingData] = useState([]);
  const [pendingTotal, setPendingTotal] = useState(0);
  const [AnnounceMonthlyData, setAnnounceMonthlyData] = useState([]);
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  // Admin toggle: which monthly ad is mid-update for "paid directly".
  const [paidDirectlyLoadingId, setPaidDirectlyLoadingId] = useState(null);
  const [accountFilings, setAccountFilings] = useState([]);
  const [accountFilingsLoading, setAccountFilingsLoading] = useState(false);
  const [accountFilingsTotal, setAccountFilingsTotal] = useState(0);
  const [accountFilingsPage, setAccountFilingsPage] = useState(0);
  const [accountFilingsRowsPerPage, setAccountFilingsRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pagepending, setPagepending] = useState(0);
  const [rowsPerPagepending, setRowsPerPagepending] = useState(5);
  const [monthlyPage, setMonthlyPage] = useState(0);
  const [monthlyRowsPerPage, setMonthlyRowsPerPage] = useState(5);
  const [publicationDate, setPublicationDate] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [openModelDate, setOpenModelDate] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [editFormData, setEditFormData] = useState({
    billing_address_type: "another_address",
    billing_address_denomination: "",
    billing_address_civility: "",
    billing_address_nom: "",
    billing_address_prenom: "",
    billing_address_code_postal: "",
    billing_address_address: "",
    billing_address_ville: "",
    billing_address_ville_id: "",
    billing_address_villeArr: [],
  });
  //-- add code
  const [rowData, setRowData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEls, setAnchorEls] = useState({});
  const [anchorElsPending, setAnchorElsPending] = useState({});
  const [ConfirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [creditData, setCreditData] = useState({
    totalDiscounts: 0,
    consumedDiscounts: 0,
    consumedBalance: 0,
    remainingBalance: 0,
    pendingDiscounts: 0,
    paymentHistory: []
  });
  const [dateRange, setDateRange] = useState({
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
  });
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
const [paymentData, setPaymentData] = useState({
  amount: '',
  paymentDate: new Date().toISOString().split('T')[0],
  reference: `Paiement des remises - ${new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}`
});
const [paymentErrors, setPaymentErrors] = useState({});
  
  const [isLoadingCredits, setIsLoadingCredits] = useState(false);
  const [isMarkingAsPaid, setIsMarkingAsPaid] = useState(false);

  const fetchPartnerCredits = async (userId) => {
    setIsLoadingCredits(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/user/credits/${userId}`,
        { 
          params: {
            start_date: moment(dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
            end_date: moment(dateRange.endDate).format('YYYY-MM-DD 23:59:59')
          },
          headers: authHeader() 
        }
      );
      setCreditData({
        totalDiscounts: response.data.data.total_discounts || 0,
        consumedDiscounts: response.data.data.consumed_discounts || 0,
        pendingDiscounts: response.data.data.pending_discounts || 0,
        consumedBalance: response.data.data.consumed_balance || 0,
        remainingBalance: response.data.data.remaining_balance || 0,
        paymentHistory: response.data.data.payment_history || []
      });
    } catch (error) {
      console.error('Error fetching partner credits:', error);
      dispatch(alertActions.error("Erreur lors du chargement des crédits partenaires"));
    } finally {
      setIsLoadingCredits(false);
    }
  };
  const handleOpenPaymentDialog = () => {
    setPaymentData(prev => ({
      ...prev,
      amount: userData.balance_discount || '0.00',
      paymentDate: new Date().toISOString().split('T')[0],
      reference: `Paiement des remises - ${new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}`
    }));
    setPaymentErrors({});
    setPaymentDialogOpen(true);
  };
  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'amount') {
      const numericValue = parseFloat(value);
      // Handle empty string case
      if (value === '') {
        setPaymentData(prev => ({ ...prev, [name]: '' }));
        return;
      }
      
      // Check if it's a valid number
      if (isNaN(numericValue)) {
        return;
      }
      
      // Ensure value is not less than 0.01
      const minValue = 0.01;
      const maxValue = userData.balance_discount ? parseFloat(userData.balance_discount) : Number.MAX_SAFE_INTEGER;
      
      let newValue = numericValue;
      
      if (newValue < minValue) {
        newValue = minValue;
      } else if (newValue > maxValue) {
        newValue = maxValue;
      }
      
      setPaymentData(prev => ({
        ...prev,
        [name]: newValue
      }));
      return;
    }
    
    // For other fields
    setPaymentData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const validatePayment = () => {
    const errors = {};
    if (!paymentData.amount || isNaN(paymentData.amount) || parseFloat(paymentData.amount) <= 0) {
      errors.amount = "Veuillez entrer un montant valide";
    }
    if (!paymentData.paymentDate) {
      errors.paymentDate = "Veuillez sélectionner une date";
    }
    if (!paymentData.reference.trim()) {
      errors.reference = "Veuillez entrer une référence";
    }
    setPaymentErrors(errors);
    return Object.keys(errors).length === 0;
  };
  
  const handleSubmitPayment = async () => {
    if (!validatePayment()) return;
  
    setIsMarkingAsPaid(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/user/credits`,
        { 
          user_id: params.user_id,
          amount: parseFloat(paymentData.amount),
          date_payment: paymentData.paymentDate,
          reference: paymentData.reference
        },
        { headers: authHeader() }
      );
      if (response.data.sucess) 
      {
        dispatch(alertActions.success("Le paiement a été enregistré avec succès"));
        setPaymentDialogOpen(false);
        await getAllUsers(params.user_id);
        await fetchPartnerCredits(params.user_id);
      } 
      else 
      {
        dispatch(alertActions.error(response.data.message || "Une erreur s'est produite"));
      }
    } catch (error) {
      console.error('Error recording payment:', error);
      dispatch(alertActions.error("Erreur lors de l'enregistrement du paiement"));
    } finally 
    {
      setPaymentDialogOpen(false);
      setIsMarkingAsPaid(false);
    }
  };
  
  useEffect(() => {
    if (params.user_id) {
      fetchPartnerCredits(params.user_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange.startDate, dateRange.endDate, params.user_id]);
  const visibleRows = useMemo(
    () => stableSort(AnnounceData, getComparator(order, orderBy)),
    [order, orderBy, AnnounceData]
  );
  const visibleRowsFacture = useMemo(
    () => stableSort(FactureData, getComparator(order, orderBy)),
    [order, orderBy, FactureData]
  );
  const visibleRowsPending = useMemo(
    () => stableSort(AnnouncePendingData, getComparator(order, orderBy)),
    [order, orderBy, AnnouncePendingData]
  );

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchAnnonces(params.user_id, newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchAnnonces(params.user_id, 0, newRowsPerPage);
  };
  const handleChangePagepending = (event, newPage) => {
    setPagepending(newPage);
    fetchAnnouncePending(params.user_id, newPage, rowsPerPagepending);
  };

  const handleChangeRowsPerPagepending = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPagepending(newRowsPerPage);
    setPagepending(0);
    fetchAnnouncePending(params.user_id, 0, newRowsPerPage);
  };

  const handleMonthlyChangePage = (event, newPage) => {
    setMonthlyPage(newPage);
    fetchAnnounceMonthly(params.user_id, newPage, monthlyRowsPerPage);
  };

  const handleMonthlyChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setMonthlyRowsPerPage(newRowsPerPage);
    setMonthlyPage(0);
    fetchAnnounceMonthly(params.user_id, 0, newRowsPerPage);
  };

  const handleClick1 = (event, id) => {
    // setAnchorEl(event.currentTarget);
    setAnchorEls((prev) => ({ ...prev, [id]: event.currentTarget }));
  };
  const handleClick1Pending = (event, id) => {
    // setAnchorEl(event.currentTarget);
    setAnchorElsPending((prev) => ({ ...prev, [id]: event.currentTarget }));
  };
  const handleClose1Pending = (id) => {
    // setAnchorEl(null);
    setAnchorElsPending((prev) => ({ ...prev, [id]: null }));
  };

  const handleClose1 = (id) => {
    // setAnchorEl(null);
    setAnchorEls((prev) => ({ ...prev, [id]: null }));
  };
  const handleCloseModel = () => {
    setOpenModel(false);
    setSubmitted(false);
  };
  const handleSubmitModel = async () => {
    /* console.log("editFormData",editFormData)
    console.log("rowData",rowData) */
    let billing_address_json_data = rowData.billing_address_json;
    let billing_address_json_parse = billing_address_json_data;
    if (billing_address_json_parse != null) {
      billing_address_json_parse = JSON.parse(billing_address_json_parse);
      billing_address_json_parse.billing_address_denomination =
        editFormData.billing_address_denomination;
      billing_address_json_parse.billing_address_civility =
        editFormData.billing_address_civility;
      billing_address_json_parse.billing_address_nom =
        editFormData.billing_address_nom;
      billing_address_json_parse.billing_address_prenom =
        editFormData.billing_address_prenom;
      billing_address_json_parse.billing_address_address =
        editFormData.billing_address_address;
      billing_address_json_parse.billing_address_code_postal =
        editFormData.billing_address_code_postal;
      billing_address_json_parse.billing_address_ville =
        editFormData.billing_address_ville;
      billing_address_json_parse.billing_address_villeArr =
        editFormData.billing_address_villeArr;
      billing_address_json_parse.billing_address_ville_id =
        editFormData.billing_address_ville_id;
    } else {
      billing_address_json_parse = editFormData;
    }

    setSuccessful(false);

    if (
      editFormData.billing_address_denomination &&
      editFormData.billing_address_civility &&
      editFormData.billing_address_nom &&
      editFormData.billing_address_prenom &&
      editFormData.billing_address_address &&
      editFormData.billing_address_code_postal &&
      editFormData.billing_address_ville_id
    ) {
      setSubmitted(false);
      setLoading(true);
      try {
        let sendData = {
          announce_id: rowData.id,
          editFormData: editFormData,
          billing_address_json: billing_address_json_parse,
        };
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}api/announce/update_invoice`,
          sendData
        );

        dispatch(alertActions.success(response.data.msg));
        setSuccessful(true);
        setOpenModel(false);
        setSubmitted(false);
        setLoading(false);
        getAllUsers(params.user_id);
      } catch (error) {
        console.error(error);
        dispatch(
          alertActions.error("Une erreur s'est produite. Veuillez réessayer!")
        );
        setSuccessful(true);
        setSubmitted(false);
        setLoading(false);
      }
    } else {
      setSubmitted(true);
      setLoading(false);
    }
  };
  const handleChangeModel = (e) => {
    let billing_address_json_parse = rowData.billing_address_json;
    let { name, value } = e.target;
    setEditFormData((editFormData) => ({ ...editFormData, [name]: value }));

    if (name == "billing_address_ville_id") {
      let filterCity = editFormData.billing_address_villeArr.filter(
        (cityVal) => cityVal.id === value
      );
      if (filterCity.length > 0) {
        setEditFormData((editFormData) => ({
          ...editFormData,
          ["billing_address_ville"]: filterCity[0].city,
        }));
      }
    }

    if (name == "billing_address_code_postal") {
      const getData = setTimeout(async () => {
        setEditFormData((editFormData) => ({
          ...editFormData,
          billing_address_ville: "",
          billing_address_ville_id: "",
          billing_address_villeArr: [],
        }));
        if (value.length > 0) {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`
          );
          if (response.data && response.data.data) {
            setEditFormData((editFormData) => ({
              ...editFormData,
              billing_address_ville: response.data.data.city,
              billing_address_ville_id: response.data.data.id,
              billing_address_villeArr: response.data.data.cityArr,
            }));
          }
        }
      }, 1000);
      return () => clearTimeout(getData);
    }
    // setOpenModel(true)
    /* setConfirmOpen(true);
    setDeleteId(rowData.id); */
  };
  const handleClickEditInvoice = (e, rowData) => {
    handleClose1(rowData.id);
    setOpenModel(true);
    setRowData(rowData);
    if (rowData.billing_address_json != null) {
      let billing_address_json_parse = JSON.parse(rowData.billing_address_json);
      setEditFormData({
        billing_address_type: "another_address",
        billing_address_denomination:
          billing_address_json_parse.billing_address_denomination,
        billing_address_civility:
          billing_address_json_parse.billing_address_civility,
        billing_address_nom: billing_address_json_parse.billing_address_nom,
        billing_address_prenom:
          billing_address_json_parse.billing_address_prenom,
        billing_address_code_postal:
          billing_address_json_parse.billing_address_code_postal,
        billing_address_address:
          billing_address_json_parse.billing_address_address,
        billing_address_ville: billing_address_json_parse.billing_address_ville,
        billing_address_ville_id:
          billing_address_json_parse.billing_address_ville_id,
        billing_address_villeArr:
          billing_address_json_parse.billing_address_villeArr,
      });
    }
    /* setConfirmOpen(true);
    setDeleteId(rowData.id); */
  };
  const handleClickSend = (e, rowData) => {};
  const handleClickEdit = (e, rowData) => {
    // console.log("rowData",rowData)
    localStorage.setItem("fromAdmin", true);
    let url_title = rowData.title.replace(/\s+/g, "-");
    const url = `/nos-formulaires/${url_title}/${rowData.add_type}/${rowData.id}`;
    window.open(url, "_blank");
  };
  const handleClick = (e, rowData) => {
    setConfirmOpen(true);
    setDeleteId(rowData.id);
    handleClose1(rowData.id);
  };

  const handleCancel = () => {
    setConfirmOpen(false);
  };

  const handleOk = async () => {
    setConfirmOpen(false);

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}api/announce/device/${deleteId}`
      );
      if (response.data.sucess === true) {
        dispatch(alertActions.success(response.data.msg));
        getAllUsers(params.user_id);
        // setRows(prevItems =>prevItems.filter(item =>item.id !== rowData.deleteId));
      } else {
        dispatch(alertActions.error(response.data.msg));
      }
    } catch (error) {
      console.error(error);
    }
  };

  //-- code end

  const [userData, setUserData] = useState({
    id: "",
    siren: "",
    raisosociale: "",
    civil: "",
    firstname: "",
    lastname: "",
    telephone: "",
    email: "",
    adresse: "",
    ville: "",
    ville_id:"",
    villeArr:[],
    postalcode: "",
    accounttype: [],
    payment_plan: "",
    forfaitaires: "",
    modification: "",
    forfaitaires_other: "",
    modification_other: "",
    profile_image_old: "",
    balance_discount: 0,
    updateType: "admin",
  });


  const fetchFactures = async (userId, pageNum = facturePage, limit = factureRowsPerPage) => {
    if (!userId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/user/${userId}/annonces`,
        {
          params: { page: pageNum + 1, limit },
          headers: authHeader(),
        }
      );
      setFactureData(response.data.data || []);
      setFactureTotal(response.data.pagination?.total || 0);
    } catch (error) {
      console.error("Error fetching factures:", error);
    }
  };

  const handleChangeFacturePage = (event, newPage) => {
    setFacturePage(newPage);
    fetchFactures(params.user_id, newPage, factureRowsPerPage);
  };

  const handleChangeFactureRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setFactureRowsPerPage(newRowsPerPage);
    setFacturePage(0);
    fetchFactures(params.user_id, 0, newRowsPerPage);
  };

  const fetchAnnonces = async (userId, pageNum = page, limit = rowsPerPage) => {
    if (!userId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/user/${userId}/annonces`,
        {
          params: { page: pageNum + 1, limit },
          headers: authHeader(),
        }
      );
      setAnnounceData(response.data.data || []);
      setAnnounceTotal(response.data.pagination?.total || 0);
    } catch (error) {
      console.error("Error fetching annonces:", error);
    }
  };

  const fetchAnnouncePending = async (userId, pageNum = pagepending, limit = rowsPerPagepending) => {
    if (!userId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/user/${userId}/annonces-pending`,
        {
          params: { page: pageNum + 1, limit },
          headers: authHeader(),
        }
      );
      setAnnouncePendingData(response.data.data || []);
      setPendingTotal(response.data.pagination?.total || 0);
    } catch (error) {
      console.error("Error fetching annonces pending:", error);
    }
  };

  const fetchAnnounceMonthly = async (userId, pageNum = monthlyPage, limit = monthlyRowsPerPage) => {
    if (!userId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/user/${userId}/annonces-monthly`,
        {
          params: { page: pageNum + 1, limit },
          headers: authHeader(),
        }
      );
      setAnnounceMonthlyData(response.data.data || []);
      setMonthlyTotal(response.data.pagination?.total || 0);
    } catch (error) {
      console.error("Error fetching annonces monthly:", error);
    }
  };

  // Flag/un-flag a monthly ad as paid directly outside the prélèvement cycle.
  // The backend deducts it from the monthly statement's reste-dû.
  const handleTogglePaidDirectly = async (row) => {
    const next = Number(row.paid_directly) === 1 ? 0 : 1;
    setPaidDirectlyLoadingId(row.id);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/admin/announce/${row.id}/paid-directly`,
        { paid_directly: next },
        { headers: authHeader() }
      );
      if (response.data && (response.data.success || response.data.sucess)) {
        setAnnounceMonthlyData((prev) =>
          prev.map((a) => (a.id === row.id ? { ...a, paid_directly: next } : a))
        );
        dispatch(alertActions.success(response.data.msg));
      } else {
        dispatch(
          alertActions.error((response.data && response.data.msg) || "Échec de la mise à jour")
        );
      }
    } catch (error) {
      dispatch(alertActions.error("Erreur lors de la mise à jour du paiement direct"));
    } finally {
      setPaidDirectlyLoadingId(null);
    }
  };

  useEffect(() => {
    // console.log("params",params)
    getAllUsers(params.user_id);
    fetchAccountFilings(params.user_id);
    fetchAnnonces(params.user_id);
    fetchFactures(params.user_id);
    fetchAnnouncePending(params.user_id);
    fetchAnnounceMonthly(params.user_id);
  }, []);

  const fetchAccountFilings = async (userId, pageNum = accountFilingsPage, limit = accountFilingsRowsPerPage) => {
    if (!userId) return;
    setAccountFilingsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/admin/deposit-accounts`,
        {
          params: { userId, page: pageNum + 1, limit },
          headers: authHeader(),
        }
      );
      setAccountFilings(Array.isArray(response.data?.data) ? response.data.data : []);
      setAccountFilingsTotal(response.data.pagination?.total || 0);
    } catch (error) {
      console.error(error);
      setAccountFilings([]);
    } finally {
      setAccountFilingsLoading(false);
    }
  };

  async function getAllUsers(user_id) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/user/${user_id}`
      );
      //console.log("response",response)
      setUserDetails(response.data.data);
      //setAnnounceData(response.data.announce_data);
      //setAnnouncePendingData(response.data.announce_pending_data);
      //setAnnounceMonthlyData(response.data.annoncesDataMonthly);
      if (response.data.data) {
        setUserData({
          id: user_id,
          siren: response.data.data.siren,
          raisosociale: response.data.data.raisosociale,
          civil: response.data.data.civil,
          firstname: response.data.data.firstname,
          lastname: response.data.data.lastname,
          telephone: response.data.data.telephone,
          email: response.data.data.email,
          adresse: response.data.data.address,
          ville: response.data.data.ville,
          ville_id: response.data.data.ville_id,
          villeArr:response.data.data && response.data.data.villeArr? JSON.parse(response.data.data.villeArr): [],
          postalcode: response.data.data.postalcode,
          accounttype: response.data.data.accounttype
            ? response.data.data.accounttype.split(",")
            : [],
          payment_plan: response.data.data.payment_plan,
          profile_image_old: response.data.data.profile_image,
          forfaitaires: response.data.data.forfaitaires,
          modification: response.data.data.modification,
          forfaitaires_other: response.data.data.forfaitaires_other,
          modification_other: response.data.data.modification_other,
          balance_discount: response.data.data.balance_discount,
          updateType: "admin",
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  const handlePostalcodeChange=async(value)=>{
    try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`
          );

          if (response.data && response.data.data) {
            setUserData((userData) => ({
              ...userData,
              ville: response.data.data.city,
              ville_id: response.data.data.id,
              villeArr: response.data.data.cityArr,
            }));
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
  }
const handleChange = (event) => {
    const { name, value } = event.target;
    
    if (name === "accounttype") {
      if (event.target.checked) {
        setUserData((userData) => ({
          ...userData,
          accounttype: [...userData["accounttype"], value],
        }));
      } else {
        setUserData((userData) => ({
          ...userData,
          accounttype: [
            ...userData["accounttype"].filter(
              (item) => item !== value
            ),
          ],
        }));
      }
    } else {
      setUserData((userData) => ({
        ...userData,
        [name]: value,
      }));
    }
    if (name === "postalcode") 
    {
      handlePostalcodeChange(value);
    }

    // Handle city selection from dropdown
    if (name === "ville_id") {
      if (userData.villeArr && Array.isArray(userData.villeArr)) {
        let filterCity = userData.villeArr.filter((cityVal) => cityVal.id === value);
        if (filterCity.length > 0) {
          setUserData((userData) => ({
            ...userData,
            ville: filterCity[0].city,
            ville_id: filterCity[0].id,
          }));
        }
      }
    }
  };
  const handleUpdate = async (user_data) => {
    // console.log("user_data",user_data)
    setSuccessful(false);
    try {
      const response = await axios.put(
        process.env.REACT_APP_API_URL + `api/user/${user_data.id}`,
        user_data,
        authHeader()
      );
      setSuccessful(true);
      if (response.data.sucess === true) {
        dispatch(alertActions.success(response.data.msg));
        getAllUsers(params.user_id);
      } else {
        dispatch(alertActions.error(response.data.msg));
      }
      // const user_data = response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const handleClickEditDate = (e, rowData) => {
    // console.log("rowData.date_parution",rowData.date_parution)
    setRowData(rowData);
    setPublicationDate(moment(rowData.date_parution).format("YYYY-MM-DD"));
    setOpenModelDate(true);
    handleClose1(rowData.id);
  };

  const handleCloseModelDate = () => {
    setOpenModelDate(false);
    setSubmitted(false);
  };
  const handleSubmitModelDate = async () => {
    // setOpenModelDate(false);
    setLoading(true);
    setSuccessful(false);
    let publishDate = moment(publicationDate).format("YYYY-MM-DD");

    if (rowData) {
      try {
        let sendData = {
          announce_id: rowData.id,
          pubishdate: publishDate,
        };
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}api/announce/changepublishdate`,
          sendData
        );
        console.log("response", response.data.data);
        dispatch(alertActions.success(response.data.msg));
        setSuccessful(true);
        setOpenModelDate(false);
        setSubmitted(false);
        setLoading(false);
        setOpenModelDate(false);
        handleClose1(rowData.id);
        getAllUsers(params.user_id);
      } catch (error) {
        console.error(error);
        dispatch(
          alertActions.error("Une erreur s'est produite. Veuillez réessayer!")
        );
        setSuccessful(true);
        setSubmitted(false);
        setLoading(false);
      }
    }
  };
  const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" to="/">
      Tableau de bord
    </Link>,
    <Link underline="hover" key="1" color="inherit" to="/admin/clients">
      Gestion des clients
    </Link>,
    <Typography key="3">Tous les utilisateurs</Typography>,
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const currentAdmin = useSelector((state) => state.administrator.admin);

  if (!currentAdmin) {
    return <Navigate to="/admin/login" />;
  }

  return (
    <>
      {successful ? (
        <ToastMessageComp message={alert.message} type={alert.type} />
      ) : (
        ""
      )}

      <div className=" w-full h-full bg-white p-8">
        <Typography
          variant="h4"
          component="h4"
          fontWeight={500}
          color={"#1CBE93"}
        >
          Tous les utilisateurs
        </Typography>
        <Stack spacing={2} mb={3}>
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            {breadcrumbs}
          </Breadcrumbs>
        </Stack>
        <Grid container spacing={4}>
                <Grid xs={4}>
                  <Typography
                    variant="h6"
                    component="h6"
                    fontWeight={400}
                    sx={{ textAlign: "left" }}
                    color={"#27295B"}
                  >
                    Les informations personnelles
                  </Typography>
                  <div className="flex flex-col justify-center items-center gap-4 pt-24">
                    <svg
                      width="120"
                      height="120"
                      viewBox="0 0 61 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.5 0C13.664 0 0 13.664 0 30.5C0 47.336 13.664 61 30.5 61C47.336 61 61 47.336 61 30.5C61 13.664 47.336 0 30.5 0ZM30.5 12.2C36.3865 12.2 41.175 16.9885 41.175 22.875C41.175 28.7615 36.3865 33.55 30.5 33.55C24.6135 33.55 19.825 28.7615 19.825 22.875C19.825 16.9885 24.6135 12.2 30.5 12.2ZM30.5 54.9C24.3085 54.9 16.9885 52.399 11.773 46.116C17.1154 41.9244 23.7095 39.6464 30.5 39.6464C37.2905 39.6464 43.8846 41.9244 49.227 46.116C44.0115 52.399 36.6915 54.9 30.5 54.9Z"
                        fill="#DEE3E2"
                      />
                    </svg>

                    <h3 className="text-lg text-primary font-semibold">
                      {userData.firstname} {userData.lastname}
                    </h3>
                    <div>
                      <Button
                        component={Link}
                        // to={`/admin/modelelibre/${userData.id}`}
                        to={{
                          pathname: `/admin/modelelibre/${userData.id}/0`,
                          state: { currentUser: userData },
                        }}
                        variant="contained"
                        className="bg-primary  btnShadow  my-4 font-bold text-sm text-white  py-3   rounded-lg hover:bg-secondary  transition-all duration-300"
                      >
                        Créer une nouvelle commande
                      </Button>
                      {/* <Button  onClick={()=>handleUpdate(userData)}  variant="contained" className='bg-primary  btnShadow  my-4 font-bold text-sm text-white  py-3   rounded-lg hover:bg-secondary  transition-all duration-300'>Créer une nouvelle commande</Button> */}
                    </div>
                  </div>
                </Grid>
                <Grid xs={8}>
                  <Typography
                    variant="h6"
                    component="h6"
                    fontWeight={400}
                    sx={{ textAlign: "left" }}
                    color={"#27295B"}
                  >
                    Informations de base
                  </Typography>
                  <Stack direction="row" spacing={2} className="pt-4">
                    <TextField
                      label="Siren"
                      variant="outlined"
                      fullWidth
                      name="siren"
                      onChange={handleChange}
                      value={userData.siren}
                      required
                      error={!userData.siren}
                      helperText={!userData.siren ? "Ce champ est obligatoire" : ""}
                    />
                    <TextField
                      label="Nom de la Société"
                      variant="outlined"
                      fullWidth
                      value={userData.raisosociale}
                      name="raisosociale"
                      onChange={handleChange}
                      required
                      error={!userData.raisosociale}
                      helperText={!userData.raisosociale ? "Ce champ est obligatoire" : ""}
                    />
                    <FormControl fullWidth sx={{ textAlign: "left" }} required error={!userData.civil}>
                      <InputLabel id="demo-simple-select-label">
                        Civilité
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={civilite}
                        label="Civilite"
                        name="civil"
                        onChange={handleChange}
                        value={
                          userData.civil !== "null" && userData.civil !== null
                            ? userData.civil
                            : "M"
                        }
                      >
                        <MenuItem value={"M"}>M</MenuItem>
                        <MenuItem value={"MME"}>MME</MenuItem>
                      </Select>
                    </FormControl>
                  </Stack>
                  <Stack direction="row" spacing={2} className="pt-4">
                    <TextField
                      label="Nom"
                      variant="outlined"
                      fullWidth
                      name="firstname"
                      value={userData.firstname}
                      onChange={(e) => handleChange(e)}
                      required
                      error={!userData.firstname}
                      helperText={!userData.firstname ? "Ce champ est obligatoire" : ""}
                    />
                    <TextField
                      label="Prénom"
                      variant="outlined"
                      fullWidth
                      name="lastname"
                      value={userData.lastname}
                      onChange={(e) => handleChange(e)}
                      required
                      error={!userData.lastname}
                      helperText={!userData.lastname ? "Ce champ est obligatoire" : ""}
                    />
                    <TextField
                      label="Téléphone"
                      variant="outlined"
                      fullWidth
                      name="telephone"
                      value={userData.telephone}
                      onChange={(e) => handleChange(e)}
                      required
                      error={!userData.telephone}
                      helperText={!userData.telephone ? "Ce champ est obligatoire" : ""}
                    />
                  </Stack>
                  <Stack direction="row" spacing={2} className="pt-4">
                    <TextField
                      label="Addresse"
                      variant="outlined"
                      fullWidth
                      name="adresse"
                      value={userData.adresse}
                      onChange={(e) => handleChange(e)}
                      required
                      error={!userData.adresse}
                      helperText={!userData.adresse ? "Ce champ est obligatoire" : ""}
                    />
                  </Stack>
                  <Stack direction="row" spacing={2} className="pt-4">
                    <TextField
                      label="Addresse email"
                      variant="outlined"
                      disabled
                      fullWidth
                      name="email"
                      value={userData.email}
                      onChange={(e) => handleChange(e)}
                      required
                      error={!userData.email}
                      helperText={!userData.email ? "Ce champ est obligatoire" : ""}
                    />
                    <TextField
                      label="Code postal"
                      variant="outlined"
                      fullWidth
                      name="postalcode"
                      value={userData.postalcode}
                      onChange={(e) => handleChange(e)}
                      required
                      error={!userData.postalcode}
                      helperText={!userData.postalcode ? "Ce champ est obligatoire" : ""}
                    />
                    <FormControl fullWidth required error={!userData.ville}>
                      <InputLabel id="ville-label">Ville</InputLabel>
                      <Select
                        labelId="ville-label"
                        label="Ville"
                        variant="outlined"
                        id="ville_id"
                        name="ville_id"
                        value={userData.ville_id}
                        onChange={(e) => handleChange(e)}
                      >
                        {userData.villeArr && userData.villeArr.length > 0 ? (
                          userData.villeArr.map((cityVal, cityIndex) => (
                            <MenuItem key={cityIndex} value={cityVal.id}>
                              {cityVal.city}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="" disabled>
                            Entrez d'abord le code postal
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    
                  </Stack>
                  <Stack direction="row" spacing={2} className="pt-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="accounttype"
                          checked={
                            userData.accounttype.includes("professional")
                              ? true
                              : false
                          }
                          value={"professional"}
                          onChange={(e) => handleChange(e)}
                        />
                      }
                      label="Compte Professionnel"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="accounttype"
                          checked={
                            userData.accounttype.includes("free") ? true : false
                          }
                          value={"free"}
                          onChange={(e) => handleChange(e)}
                        />
                      }
                      label="Modèle libre"
                    />
                  </Stack>
                  {userData.accounttype.includes("professional") ? (
                    <>
                      <Typography
                        variant="h5"
                        component="h5"
                        fontWeight={"bold"}
                        pt={2}
                        sx={{ textAlign: "left" }}
                        color={"#27295B"}
                      >
                        Gestion des remises
                      </Typography>
                      <Typography
                        variant="h6"
                        component="h6"
                        fontWeight={400}
                        pt={0}
                        sx={{ textAlign: "left" }}
                        color={"#27295B"}
                      >
                        Remise  journaux partenaires
                      </Typography>
                      <Stack direction="row" spacing={2} className="pt-4">
                        <TextField
                          label="Forfaitaires"
                          variant="outlined"
                          fullWidth
                          name="forfaitaires"
                          value={userData.forfaitaires}
                          onChange={(e) => handleChange(e)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">% </InputAdornment>
                            ),
                          }}
                          required
                          error={!userData.forfaitaires}
                          helperText={!userData.forfaitaires ? "Ce champ est obligatoire" : ""}
                        />
                        <TextField
                          label="Caractère"
                          variant="outlined"
                          fullWidth
                          name="modification"
                          value={userData.modification}
                          onChange={(e) => handleChange(e)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">% </InputAdornment>
                            ),
                          }}
                          required
                          error={!userData.modification}
                          helperText={!userData.modification ? "Ce champ est obligatoire" : ""}
                        />

                      </Stack>
                      <Typography
                        variant="h6"
                        component="h6"
                        fontWeight={400}
                        pt={0}
                        sx={{ textAlign: "left" }}
                        color={"#27295B"}
                      >
                        Remise autres journaux
                      </Typography>
                      <Stack direction="row" spacing={2} className="pt-4">
                        <TextField
                          label="Forfaitaires"
                          variant="outlined"
                          fullWidth
                          name="forfaitaires_other"
                          value={userData.forfaitaires_other}
                          onChange={(e) => handleChange(e)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">% </InputAdornment>
                            ),
                          }}
                          required
                          error={!userData.forfaitaires_other}
                          helperText={!userData.forfaitaires_other ? "Ce champ est obligatoire" : ""}
                        />
                        <TextField
                          label="Caractère"
                          variant="outlined"
                          fullWidth
                          name="modification_other"
                          value={userData.modification_other}
                          onChange={(e) => handleChange(e)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">% </InputAdornment>
                            ),
                          }}
                          required
                          error={!userData.modification_other}
                          helperText={!userData.modification_other ? "Ce champ est obligatoire" : ""}
                        />
                      </Stack>
                      {" "}
                    </>
                  ) : (
                    ""
                  )}
                  <Typography
                    variant="h6"
                    component="h6"
                    fontWeight={400}
                    pt={2}
                    sx={{ textAlign: "left" }}
                    color={"#27295B"}
                  >
                    Mode depaiement
                  </Typography>
                  <Stack direction="row" spacing={2}>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      row
                    >
                      <FormControlLabel
                        control={
                          <Radio
                            name="payment_plan"
                            checked={
                              userData.payment_plan === "imediate"
                                ? true
                                : false
                            }
                            value="imediate"
                            onChange={(e) => handleChange(e)}
                          />
                        }
                        label="Paiement Immédiat"
                      />
                      <FormControlLabel
                        control={
                          <Radio
                            name="payment_plan"
                            checked={
                              userData.payment_plan === "monthly" ? true : false
                            }
                            value="monthly"
                            onChange={(e) => handleChange(e)}
                          />
                        }
                        label=" Paiement mensuel"
                      />
                    </RadioGroup>
                  </Stack>
                  <Box sx={{ textAlign: "left" }}>
                    <Button
                      onClick={() => handleUpdate(userData)}
                      variant="contained"
                      className="bg-secondary btnShadow w-1/2  my-4 font-bold text-sm text-white  py-3   rounded-lg hover:bg-primary transition-all duration-300"
                    >
                      Mettre à jour
                    </Button>
                  </Box>
                </Grid>
              </Grid>

              <Typography
  variant="h6"
  sx={{ mt: 4, mb: 2, fontWeight: "bold" }}
  color={"#27295B"}
>
  Gestion des crédits partenaires
</Typography>

{/* Date Range Picker */}
<Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
  <TextField
    label="Date de début"
    type="date"
    value={dateRange.startDate}
    onChange={(e) => {
      const newDate = e.target.value;
      setDateRange(prev => ({ ...prev, startDate: newDate }));
    }}
    InputLabelProps={{
      shrink: true,
    }}
    sx={{ minWidth: 200 }}
  />
  <Typography>au</Typography>
  <TextField
    label="Date de fin"
    type="date"
    value={dateRange.endDate}
    onChange={(e) => {
      const newDate = e.target.value;
      setDateRange(prev => ({ ...prev, endDate: newDate }));
    }}
    InputLabelProps={{
      shrink: true,
    }}
    sx={{ minWidth: 200, mr: 2 }}
  />
  <Button 
    variant="outlined" 
    onClick={() => fetchPartnerCredits(params.user_id)}
    disabled={isLoadingCredits}
    startIcon={isLoadingCredits ? <CircularProgress size={20} /> : <RefreshIcon />}
  >
    Actualiser
  </Button>
</Box>

<Grid container spacing={3} sx={{ mb: 4 }}>
  <Grid item xs={12} md={2}>
    <Paper sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="subtitle1" color="text.secondary">
        Total Remises Générées ({moment(dateRange.startDate).format('DD/MM/YY')} - {moment(dateRange.endDate).format('DD/MM/YY')})
      </Typography>
      <Typography variant="h5" sx={{ mt: 1, fontWeight: 'bold' }}>
        {isLoadingCredits ? (
          <CircularProgress size={24} />
        ) : (
          `${creditData.totalDiscounts.toFixed(2)} €`
        )}
      </Typography>
    </Paper>
  </Grid>
  <Grid item xs={12} md={2}>
    <Paper sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="subtitle1" color="text.secondary">
        Remises Consommées
      </Typography>
      <Typography variant="h5" sx={{ mt: 1, fontWeight: 'bold' }}>
        {isLoadingCredits ? (
          <CircularProgress size={24} />
        ) : (
          `${creditData.consumedDiscounts.toFixed(2)} €`
        )}
      </Typography>
    </Paper>
  </Grid>
  <Grid item xs={12} md={2}>
    <Paper sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="subtitle1" color="text.secondary">
        Solde utilisé 
      </Typography>
      <Typography variant="h5" sx={{ mt: 1, fontWeight: 'bold' }}>
        {isLoadingCredits ? (
          <CircularProgress size={24} />
        ) : (
          `${creditData.consumedBalance.toFixed(2)} €`
        )}
      </Typography>
    </Paper>
  </Grid>
  <Grid item xs={12} md={2}>
    <Paper sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="subtitle1" color="text.secondary">
        Remises Non Consommées 
      </Typography>
      
      <Typography variant="h5" sx={{ mt: 1, fontWeight: 'bold' }}>
        {isLoadingCredits ? (
          <CircularProgress size={24} />
        ) : (
          `${creditData.remainingBalance.toFixed(2)} €`
        )}
      </Typography>
    </Paper>
  </Grid>
  <Grid item xs={12} md={4}>
    <Paper sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="subtitle1" color="text.secondary">
        Solde restant (à payer)
      </Typography>
      
      <Typography variant="h5" sx={{ mt: 1, fontWeight: 'bold' }}>
        {isLoadingCredits ? (
          <CircularProgress size={24} />
        ) : (
          `${userData.balance_discount.toFixed(2)} €`
        )}
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        sx={{ mt: 2 }}
        onClick={handleOpenPaymentDialog}
        disabled={isLoadingCredits || isMarkingAsPaid || userData.balance_discount <= 0}
        >
        {isMarkingAsPaid ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Marquer comme payé"
        )}
        </Button>
    </Paper>
  </Grid>
  <Dialog 
  open={paymentDialogOpen} 
  onClose={() => !isMarkingAsPaid && setPaymentDialogOpen(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Enregistrer un paiement</DialogTitle>
  <DialogContent>
    <Box sx={{ mt: 2 }}>
    <TextField
  fullWidth
  margin="normal"
  label="Montant (€)"
  name="amount"
  type="number"
  value={paymentData.amount}
  onChange={handlePaymentInputChange}
  error={!!paymentErrors.amount}
  helperText={paymentErrors.amount || `Maximum: ${userData.balance_discount} €`}
  disabled={isMarkingAsPaid}
  inputProps={{ 
    step: "0.01", 
    min: "0.01",
    max: userData.balance_discount 
  }}
/>
      <TextField
        fullWidth
        margin="normal"
        label="Date de paiement"
        name="paymentDate"
        type="date"
        value={paymentData.paymentDate}
        onChange={handlePaymentInputChange}
        error={!!paymentErrors.paymentDate}
        helperText={paymentErrors.paymentDate}
        disabled={isMarkingAsPaid}
        InputLabelProps={{
          shrink: true,
        }}
      />
      
      <TextField
        fullWidth
        margin="normal"
        label="Référence / Note"
        name="reference"
        value={paymentData.reference}
        onChange={handlePaymentInputChange}
        error={!!paymentErrors.reference}
        helperText={paymentErrors.reference || "Ex: Paiement des remises pour Juillet 2025"}
        disabled={isMarkingAsPaid}
        multiline
        rows={3}
      />
    </Box>
  </DialogContent>
  <DialogActions>
    <Button 
      onClick={() => setPaymentDialogOpen(false)} 
      disabled={isMarkingAsPaid}
    >
      Annuler
    </Button>
    <Button 
      onClick={handleSubmitPayment} 
      variant="contained" 
      disabled={isMarkingAsPaid}
    >
      {isMarkingAsPaid ? (
        <CircularProgress size={24} />
      ) : (
        "Enregistrer le paiement"
      )}
    </Button>
  </DialogActions>
</Dialog>
</Grid>

<Grid container spacing={3} sx={{ mb: 4 }}>
  <Grid item xs={12} sx={{ mt: 2 }}>
    <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
      Historique des paiements
    </Typography>
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Montant</TableCell>
            <TableCell>Statut</TableCell>
            <TableCell>Référence</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoadingCredits ? (
            <TableRow>
              <TableCell colSpan={4} align="center">
                <CircularProgress size={24} />
              </TableCell>
            </TableRow>
          ) : creditData.paymentHistory.length > 0 ? (
            creditData.paymentHistory.map((payment, index) => (
              <TableRow key={index}>
                <TableCell>{moment(payment.date_payment).format('DD/MM/YYYY')}</TableCell>
                <TableCell>{payment.amount.toFixed(2)} €</TableCell>
                <TableCell>
                  <Chip
                    label={payment.status==1?'Payé':'Non Payé'}
                    color={payment.status === 1 ? 'success' : 'default'}
                    size="small"
                  />
                </TableCell>
                <TableCell>{payment.reference || '-'}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">
                Aucun historique de paiement disponible
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </Grid>
</Grid>   

        <Box mt={4}>
          <Typography
            variant="h6"
            component="h6"
            fontWeight={400}
            sx={{ textAlign: "left", pb: "15px" }}
            color={"#27295B"}
          >
            Gestion des commandes
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>CDE N°</TableCell>
                  <TableCell>DENOMINATION</TableCell>
                  <TableCell>TYPE ANNONCES</TableCell>
                  <TableCell>DATE DE PUBLICATION</TableCell>
                  <TableCell>ACTIONS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows &&
                  visibleRows.map((val, key) => {
                    return (
                      <>
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          key={"announce_data" + key}
                        >
                          <TableCell>{val.payment_order_id}</TableCell>
                          <TableCell>
                            {val.votre_annonce_json.denomination || val.votre_annonce_json.denomination_societe || val.votre_annonce_json.societe_name || ''}
                          </TableCell>
                          <TableCell>{val.form_type_text}</TableCell>
                          <TableCell>
                            {moment(val.date_parution).format("LL")}
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                          <TableCell align="center">
                            <div>
                              <IconButton
                                aria-label="more"
                                aria-controls={`long-menu-${val.id}`}
                                aria-haspopup="true"
                                onClick={(e) => handleClick1(e, val.id)}
                              >
                                <MoreVertIcon />
                              </IconButton>
                              <Menu
                                id={`long-menu-${val.id}`}
                                anchorEl={anchorEls[val.id]}
                                keepMounted
                                open={Boolean(anchorEls[val.id])}
                                onClose={() => handleClose1(val.id)}
                              >
                                <MenuItem
                                  key={"Modifier"}
                                  onClick={(e) => handleClickEdit(e, val)}
                                >
                                  <MdEditSquare size={25} color="green" />{" "}
                                  &nbsp;&nbsp;{"Modifier"}
                                </MenuItem>
                                <MenuItem key={"voir les annonces"}>
                                  <Anchor
                                    href={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/attestation/${val.attestation}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    <VisibilityIcon color={"primary"} />
                                    &nbsp;&nbsp;{"voir les annonces"}
                                  </Anchor>
                                </MenuItem>
                                <MenuItem
                                  onClick={(e) => handleClickEditDate(e, val)}
                                >
                                  {" "}
                                  <CalendarTodayIcon size={25} />{" "}
                                  &nbsp;&nbsp;date de parution
                                </MenuItem>

                                <MenuItem onClick={(e) => handleClick(e, val)}>
                                  {" "}
                                  <DeleteIcon
                                    size={25}
                                    style={{ color: "red" }}
                                  />{" "}
                                  &nbsp;&nbsp;Supprimer
                                </MenuItem>
                              </Menu>
                            </div>
                          </TableCell>
                        </TableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={announceTotal}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            component="h6"
            fontWeight={400}
            sx={{ textAlign: "left", pb: "15px" }}
            color={"#27295B"}
          >
            Gestion des factures
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>N° DE FACTURE</TableCell>
                  <TableCell>DENOMINATION</TableCell>
                  <TableCell>TYPE ANNONCES</TableCell>
                  <TableCell>MONTANT</TableCell>
                  <TableCell>DATE DE PUBLICATION</TableCell>
                  <TableCell>ACTIONS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRowsFacture &&
                  visibleRowsFacture.map((val, key) => {
                    return (
                      <>
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          key={"facture" + key}
                        >
                          <TableCell>{val.payment_order_id}</TableCell>
                          <TableCell>
                          {val.votre_annonce_json.denomination || val.votre_annonce_json.denomination_societe || val.votre_annonce_json.societe_name || ''}
                          </TableCell>
                          <TableCell>{val.form_type_text}</TableCell>
                          <TableCell>{val.total}</TableCell>
                          <TableCell>
                            {moment(val.date_parution).format("LL")}
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                          <TableCell align="center">
                            <div>
                              <IconButton
                                aria-label="more"
                                aria-controls={`long-menu1-${val.id}`}
                                aria-haspopup="true"
                                onClick={(e) => handleClick1Pending(e, val.id)}
                              >
                                <MoreVertIcon />
                              </IconButton>
                              <Menu
                                id={`long-menu1-${val.id}`}
                                anchorEl={anchorElsPending[val.id]}
                                keepMounted
                                open={Boolean(anchorElsPending[val.id])}
                                onClose={() => handleClose1Pending(val.id)}
                              >
                                <MenuItem
                                  onClick={(e) => handleClickEditInvoice(e, val)}
                                >
                                  <CreateIcon size={25} />
                                  &nbsp;&nbsp; Modifier
                                </MenuItem>
                                {/* <MenuItem onClick={() => console.log('Voir les annonces')}>  <Link className="" href={`${process.env.REACT_APP_API_URL}uploads/pdfgenerate/invoice/${val.votre_pdf}`} target="_blank" rel="noopener">
                                        <VisibilityIcon color={'primary'} />
                                      </Link> Voir les annonces</MenuItem> */}
                                <MenuItem key={"voir la facture"}>
                                  <Anchor
                                    href={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/invoice/${val.votre_pdf}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    <VisibilityIcon color={"primary"} /> &nbsp;{" "}
                                    {"voir la facture"}
                                  </Anchor>
                                </MenuItem>
                                {/* <MenuItem onClick={(e) => handleClickEditDate(e, val)}> <CalendarTodayIcon size={25}  /> &nbsp;&nbsp;date de parution</MenuItem> */}

                                <MenuItem onClick={(e) => handleClick(e, val)}>
                                  {" "}
                                  <DeleteIcon
                                    size={25}
                                    style={{ color: "red" }}
                                  />{" "}
                                  &nbsp;&nbsp;Supprimer
                                </MenuItem>
                              </Menu>
                            </div>
                          </TableCell>
                        </TableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={factureTotal}
            rowsPerPage={factureRowsPerPage}
            page={facturePage}
            onPageChange={handleChangeFacturePage}
            onRowsPerPageChange={handleChangeFactureRowsPerPage}
          />
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            component="h6"
            fontWeight={400}
            sx={{ textAlign: "left", pb: "15px" }}
            color={"#27295B"}
          >
            Annonces en attente (devis)
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>N° DE FACTURE</TableCell>
                  <TableCell>DENOMINATION</TableCell>
                  <TableCell>TYPE ANNONCES</TableCell>
                  <TableCell>MONTANT</TableCell>
                  <TableCell>DATE DE PUBLICATION</TableCell>
                  <TableCell>ACTIONS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRowsPending &&
                  visibleRowsPending.map((val, key) => {
                    return (
                      <>
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          key={"announce" + key}
                        >
                          <TableCell>{val.payment_order_id}</TableCell>
                          <TableCell>
                          {val.votre_annonce_json.denomination || val.votre_annonce_json.denomination_societe || val.votre_annonce_json.societe_name || ''}
                          </TableCell>
                          <TableCell>{val.form_type_text}</TableCell>
                          <TableCell>{val.total}</TableCell>
                          <TableCell>
                            {moment(val.date_parution).format("LL")}
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                          <TableCell align="center">
                            <div>
                              <IconButton
                                aria-label="more"
                                aria-controls={`long-menu1-${val.id}`}
                                aria-haspopup="true"
                                onClick={(e) => handleClick1Pending(e, val.id)}
                              >
                                <MoreVertIcon />
                              </IconButton>
                              <Menu
                                id={`long-menu1-${val.id}`}
                                anchorEl={anchorElsPending[val.id]}
                                keepMounted
                                open={Boolean(anchorElsPending[val.id])}
                                onClose={() => handleClose1Pending(val.id)}
                              >
                                <MenuItem
                                  key={"Envoyer"}
                                  onClick={(e) => handleClickSend(e, val)}
                                >
                                  <FiSend size={25} color="green" />{" "}
                                  &nbsp;&nbsp;{"Envoyer"}
                                </MenuItem>
                                {/* <MenuItem onClick={(e) => handleClickEditInvoice(e, val)} ><CreateIcon size={25}  />&nbsp;&nbsp; Modifier</MenuItem> */}
                                <MenuItem
                                  key={"Modifier"}
                                  onClick={(e) => handleClickEdit(e, val)}
                                >
                                  <MdEditSquare size={25} color="green" />{" "}
                                  &nbsp;&nbsp;{"Modifier"}
                                </MenuItem>
                                <MenuItem key={"voir la facture"}>
                                  <Anchor
                                    href={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/invoice/${val.votre_pdf}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    <VisibilityIcon color={"primary"} /> &nbsp;{" "}
                                    {"voir la facture"}
                                  </Anchor>
                                </MenuItem>
                                {/* <MenuItem onClick={(e) => handleClickEditDate(e, val)}> <CalendarTodayIcon size={25}  /> &nbsp;&nbsp;date de parution</MenuItem> */}

                                <MenuItem onClick={(e) => handleClick(e, val)}>
                                  {" "}
                                  <DeleteIcon
                                    size={25}
                                    style={{ color: "red" }}
                                  />{" "}
                                  &nbsp;&nbsp;Supprimer
                                </MenuItem>
                              </Menu>
                            </div>
                          </TableCell>
                        </TableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={pendingTotal}
            rowsPerPage={rowsPerPagepending}
            page={pagepending}
            onPageChange={handleChangePagepending}
            onRowsPerPageChange={handleChangeRowsPerPagepending}
          />
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            component="h6"
            fontWeight={400}
            sx={{ textAlign: "left", pb: "15px" }}
            color={"#27295B"}
          >
            Annonces mensuelles
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>N° DE FACTURE</TableCell>
                  <TableCell>DENOMINATION</TableCell>
                  <TableCell>TYPE ANNONCES</TableCell>
                  <TableCell>MONTANT</TableCell>
                  <TableCell>DATE DE PUBLICATION</TableCell>
                  <TableCell>PAYÉ DIRECTEMENT</TableCell>
                  <TableCell>ACTIONS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {AnnounceMonthlyData && AnnounceMonthlyData.length > 0 ? (
                  AnnounceMonthlyData
                    .map((row) => (
                      //console.log(row),
                    <TableRow key={row.invoice_number}>
                      <TableCell>{row.invoice_number}</TableCell>
                      <TableCell>{row.votre_annonce_json.denomination || row.votre_annonce_json.denomination_societe || row.votre_annonce_json.societe_name || ''}</TableCell>
                      <TableCell>{row.form_type_text}</TableCell>
                      <TableCell>{row.total}</TableCell>
                      <TableCell>{moment(row.date_parution).format("LL")}</TableCell>
                      <TableCell>
                        <Tooltip title="Marquer comme payé directement (hors prélèvement mensuel) — déduit du reste dû sur le relevé">
                          <Switch
                            size="small"
                            checked={Number(row.paid_directly) === 1}
                            disabled={paidDirectlyLoadingId === row.id}
                            onChange={() => handleTogglePaidDirectly(row)}
                          />
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <IconButton size="small">
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={monthlyTotal}
              page={monthlyPage}
              onPageChange={handleMonthlyChangePage}
              rowsPerPage={monthlyRowsPerPage}
              onRowsPerPageChange={handleMonthlyChangeRowsPerPage}
              rowsPerPageOptions={[5]}
            />
          </TableContainer>
        </Box>

        <Box mt={4}>
          <Typography
            variant="h6"
            component="h6"
            fontWeight={400}
            sx={{ textAlign: "left", pb: "15px" }}
            color={"#27295B"}
          >
            Dépôts de comptes
          </Typography>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>SIREN</TableCell>
                  <TableCell>Entreprise</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Date clôture</TableCell>
                  <TableCell>Référence INPI</TableCell>
                  <TableCell>Créé le</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {accountFilingsLoading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : accountFilings && accountFilings.length > 0 ? (
                  accountFilings
                    .map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.siren || ""}</TableCell>
                        <TableCell>{row.companyName || ""}</TableCell>
                        <TableCell>
                          <Chip
                            label={row.status || ""}
                            size="small"
                            color={
                              row.status === "validated"
                                ? "success"
                                : row.status === "rejected"
                                ? "error"
                                : row.status === "submitted"
                                ? "warning"
                                : "default"
                            }
                          />
                        </TableCell>
                        <TableCell>
                          {row.closingDate ? moment(row.closingDate,"DD/MM/YYYY").format("LL") : ""}
                        </TableCell>
                        <TableCell>{row.inpiReferenceNumber || ""}</TableCell>
                        <TableCell>
                          {row.createdAt ? moment(row.createdAt).format("LL") : ""}
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            <TablePagination
              component="div"
              count={accountFilingsTotal}
              page={accountFilingsPage}
              onPageChange={(e, newPage) => {
                setAccountFilingsPage(newPage);
                fetchAccountFilings(params.user_id, newPage, accountFilingsRowsPerPage);
              }}
              rowsPerPage={accountFilingsRowsPerPage}
              onRowsPerPageChange={(e) => {
                const newRowsPerPage = parseInt(e.target.value, 10);
                setAccountFilingsRowsPerPage(newRowsPerPage);
                setAccountFilingsPage(0);
                fetchAccountFilings(params.user_id, 0, newRowsPerPage);
              }}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </TableContainer>
        </Box>
      </div>

      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
        maxWidth="xs"
        // TransitionProps={{ onEntering: handleEntering }}
        open={ConfirmOpen}
      >
        <DialogTitle>Are you sure ?</DialogTitle>
        <DialogContent dividers>
          <p>Are you sure want to delete ?</p>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel}>
            No
          </Button>
          <Button onClick={handleOk}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openModelDate}
        onClose={handleCloseModelDate}
        maxWidth={"lg"}
      >
        <DialogTitle>Date de parution</DialogTitle>
        <DialogContent>
          <DialogContentText>Date de parution</DialogContentText>

          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="fr"
            localeText={
              frFR.components.MuiLocalizationProvider.defaultProps.localeText
            }
          >
            <DatePicker
              value={dayjs(publicationDate)}
              name="date_typepublication"
              format={"DD/MM/YYYY"}
              onChange={(date) => setPublicationDate(date.$d)}
              customInput={
                <TextField
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  size="small"
                />
              }
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModelDate}>Annuler</Button>
          {/* <Button onClick={handleSubmitModel}>Enregistrer</Button> */}
          <LoadingButton
            size="small"
            onClick={handleSubmitModelDate}
            startIcon={<SaveIcon />}
            loading={loading}
            loadingPosition="start"
            variant="contained"
          >
            <span>Sauvegarder</span>
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openModel} onClose={handleCloseModel} maxWidth={"lg"}>
        <DialogTitle>Adresse de facturation </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* To subscribe to this website, please enter your email address here. We
            will send updates occasionally. */}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="billing_address_denomination"
            name="billing_address_denomination"
            value={editFormData.billing_address_denomination}
            error={
              !editFormData.billing_address_denomination && submitted? true: false}
            onChange={handleChangeModel}
            label="Dénomination"
            type="text"
            fullWidth
            variant="standard"
            required
          />
          {/* <TextField
            autoFocus
            margin="dense"
            id="billing_address_civility"
            name="billing_address_civility"
            value={editFormData.billing_address_civility}
            error={
              !editFormData.billing_address_civility && submitted ? true : false
            }
            onChange={handleChangeModel}
            label="Civilité"
            type="text"
            fullWidth
            variant="standard"
          /> */}
         
                    
                    <InputLabel id="Civilite">Civilité</InputLabel>
              <Select
                labelId="Civilite"
                label="Civilité"
                name="billing_address_civility"
                fullWidth
                value={editFormData.billing_address_civility}
                error={!editFormData.billing_address_civility && submitted ? true : false}
                onChange={handleChangeModel}
                required
              >
              <MenuItem value={"M"}>M</MenuItem>
              <MenuItem value={"MME"}>MME</MenuItem>
            </Select>
          <TextField
            autoFocus
            margin="dense"
            id="billing_address_nom"
            name="billing_address_nom"
            value={editFormData.billing_address_nom}
            error={
              !editFormData.billing_address_nom && submitted ? true : false
            }
            onChange={handleChangeModel}
            label="Nom"
            type="text"
            fullWidth
            variant="standard"
            required
          />
          <TextField
            autoFocus
            margin="dense"
            id="billing_address_prenom"
            name="billing_address_prenom"
            value={editFormData.billing_address_prenom}
            error={
              !editFormData.billing_address_prenom && submitted ? true : false
            }
            onChange={handleChangeModel}
            label="Prénom"
            type="text"
            fullWidth
            variant="standard"
            required
          />
          <TextField
            autoFocus
            margin="dense"
            id="billing_address_address"
            name="billing_address_address"
            value={editFormData.billing_address_address}
            error={
              !editFormData.billing_address_address && submitted ? true : false
            }
            onChange={handleChangeModel}
            label="Adresse"
            type="text"
            fullWidth
            variant="standard"
            required
          />
          <TextField
            autoFocus
            margin="dense"
            id="billing_address_code_postal"
            name="billing_address_code_postal"
            value={editFormData.billing_address_code_postal}
            error={
              !editFormData.billing_address_code_postal && submitted
                ? true
                : false
            }
            onChange={handleChangeModel}
            label="Code postal"
            type="text"
            fullWidth
            variant="standard"
            required
          />
          <FormControl fullWidth margin="dense">
            <InputLabel id="demo-simple-select-label">Ville</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="billing_address_ville_id"
              name="billing_address_ville_id"
              value={editFormData.billing_address_ville_id}
              error={
                !editFormData.billing_address_ville_id && submitted
                  ? true
                  : false
              }
              label="Ville"
              onChange={handleChangeModel}
              required
            >
              {editFormData.billing_address_villeArr.map((val, key) => {
                return <MenuItem value={val.id}>{val.city}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModel}>Annuler</Button>
          {/* <Button onClick={handleSubmitModel}>Enregistrer</Button> */}
          <LoadingButton
            size="small"
            onClick={handleSubmitModel}
            startIcon={<SaveIcon />}
            loading={loading}
            loadingPosition="start"
            variant="contained"
          >
            <span>Enregistrer</span>
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
